export default "__VITE_ASSET__CxAzyjxf__"